/* Store Ec · tienda multiproducto — compra rápida, combos, reloj de oferta y fecha de entrega. Sin librerías. */
(function(){
  'use strict';
  var T = window.X13T = window.X13T || {};
  var ZONA = 'America/Guayaquil';
  var rutas = function(k, d){ return (window.routes && window.routes[k]) || d; };

  /* ---------- aviso «Añadido al carrito» ---------- */
  var aviso, avisoT;
  T.aviso = function(msg, error){
    if(!aviso){
      aviso = document.createElement('div');
      aviso.className = 'x13 x13t-aviso';
      aviso.setAttribute('role','status');
      aviso.setAttribute('aria-live','polite');
      document.body.appendChild(aviso);
    }
    aviso.classList.toggle('x13t-aviso--error', !!error);
    aviso.innerHTML = '';
    var s = document.createElement('span'); s.textContent = msg; aviso.appendChild(s);
    if(!error){ var a = document.createElement('a'); a.href = rutas('cart_url','/cart'); a.textContent = 'Ver carrito'; aviso.appendChild(a); }
    requestAnimationFrame(function(){ aviso.classList.add('is-visible'); });
    clearTimeout(avisoT); avisoT = setTimeout(function(){ aviso.classList.remove('is-visible'); }, 4000);
  };

  function burbuja(html){
    var el = document.getElementById('cart-icon-bubble'); if(!el || !html) return;
    var d = new DOMParser().parseFromString(html,'text/html'), s = d.querySelector('.shopify-section');
    if(s) el.innerHTML = s.innerHTML;
  }

  /* Agrega varios artículos. items = [{id, quantity}] */
  /* Animación breve del ícono del carrito (sin movimiento si el usuario lo pide) */
  function latido(){
    var el = document.getElementById('cart-icon-bubble'); if(!el) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    el.classList.remove('x13t-latido'); void el.offsetWidth; el.classList.add('x13t-latido');
    setTimeout(function(){ el.classList.remove('x13t-latido'); }, 700);
  }
  function enCarrito(){ var c = rutas('cart_url','/cart'); return window.location.pathname === c || window.location.pathname === '/cart'; }

  /* Agrega artículos SOLO por AJAX y sin salir de la página. items = [{id, quantity}].
     Usa /cart/update.js (suma a la cantidad actual) porque la app de paquetes del producto
     intercepta /cart/add.js, cambia la cantidad por su paquete y redirige al carrito. */
  T.agregar = function(items, boton, opciones){
    opciones = opciones || {};
    if(boton){ boton.disabled = true; boton.setAttribute('aria-busy','true'); }
    var esperado = {};
    /* Se agrega con /cart/add.js (la vía estándar): así las apps de paquetes (Section Store) pueden
       interceptar el pedido y sumar el pack elegido. Luego se lee el carrito para el aviso. */
    items.forEach(function(it){ esperado[it.id] = 0; });
    return fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify({ items: items.map(function(it){ return { id: Number(it.id), quantity: Number(it.quantity) || 1 }; }) }) })
      .then(function(r){ return r.json().then(function(j){ if(j && j.status && j.description){ throw new Error(j.description); } return fetch('/cart.js', { headers:{ Accept:'application/json' } }); }); })
      .then(function(r){ return r.json(); })
      .then(function(res){
        if(res.status){ throw new Error(res.description || res.message); }
        var corto = Object.keys(esperado).some(function(id){
          var tot = 0; (res.items || []).forEach(function(l){ if(l.variant_id === Number(id)) tot += l.quantity; });
          return tot < esperado[id];
        });
        /* contador del encabezado: se pide la sección fresca (API de secciones) después de actualizar */
        fetch(window.location.pathname + '?sections=cart-icon-bubble', { headers:{ Accept:'application/json' } })
          .then(function(r){ return r.json(); }).then(function(d){ burbuja(d['cart-icon-bubble']); latido(); }).catch(function(){});
        var n = res.item_count, txt = corto ? 'No hay más unidades disponibles de ese producto.' : (opciones.mensaje || 'Añadido al carrito.');
        /* «Añadir al carrito» NUNCA va al pago: agrega, sube el contador y abre el cajón lateral (x13-cajon.js). */
        if(!corto && !enCarrito() && window.X13C && window.X13C.abrir && window.X13C.abrir(res)){ /* cajón abierto */ }
        else T.aviso(txt + (corto ? '' : ' Tienes ' + n + (n === 1 ? ' producto.' : ' productos.')), corto);
        if(corto && !enCarrito() && window.X13C && window.X13C.abrir) window.X13C.abrir(res);
        document.dispatchEvent(new CustomEvent('x13t:carrito', { detail: res }));
        if(enCarrito() && !corto) setTimeout(function(){ window.location.reload(); }, 900);
      })
      .catch(function(e){ if(e && e.name === 'AbortError'){ T.aviso('Elige el producto que completa tu pack para continuar.', true); return; } T.aviso(e.message || 'No se pudo añadir. Intenta de nuevo.', true); })
      .finally(function(){ if(boton){ boton.disabled = false; boton.removeAttribute('aria-busy'); } });
  };

  /* Formularios de compra rápida (tarjeta «+») y combos: funcionan sin JS (envían a /cart/add) */
  document.addEventListener('submit', function(e){
    var f = e.target; if(!f || !f.matches || !window.fetch) return;
    if(f.matches('[data-x13t-mas],[data-x13t-combo]')) e.stopImmediatePropagation();
    if(f.matches('[data-x13t-mas]')){
      e.preventDefault();
      T.agregar([{ id: Number(f.querySelector('[name="id"]').value), quantity: 1 }], f.querySelector('button'));
    } else if(f.matches('[data-x13t-combo]')){
      e.preventDefault();
      var items = [];
      f.querySelectorAll('[data-combo-item]').forEach(function(i){ if(!i.disabled && (i.type !== 'checkbox' || i.checked)) items.push({ id: Number(i.value), quantity: Number(i.getAttribute('data-cantidad') || 1) }); });
      if(!items.length){ T.aviso('Elige al menos un producto.', true); return; }
      T.agregar(items, f.querySelector('button[type="submit"]'), { mensaje: items.length > 1 ? 'Añadimos ' + items.length + ' productos al carrito.' : 'Añadido al carrito.' });
    }
  }, true);

  /* ---------- reloj de oferta (zona de Ecuador, UTC−5 sin horario de verano) ---------- */
  function dos(n){ return (n < 10 ? '0' : '') + n; }
  T.reloj = function(el){
    if(!el || el.dataset.x13tListo) return; el.dataset.x13tListo = '1';
    var raw = el.getAttribute('data-termina') || '', fin = /^\d+$/.test(raw) ? Number(raw) * 1000 : Date.parse(raw);
    var caja = el.closest('[data-x13t-vence]');
    if(isNaN(fin)){ el.hidden = true; return; }
    var dd = el.querySelector('[data-d]'), hh = el.querySelector('[data-h]'), mm = el.querySelector('[data-m]'), ss = el.querySelector('[data-s]');
    function tic(){
      var falta = Math.floor((fin - Date.now()) / 1000);
      if(falta <= 0){ if(caja) caja.hidden = true; else el.hidden = true; clearInterval(t); return; }
      var d = Math.floor(falta / 86400), h = Math.floor(falta % 86400 / 3600), m = Math.floor(falta % 3600 / 60), s = falta % 60;
      if(dd){ dd.textContent = d > 0 ? d + (d === 1 ? ' día' : ' días') : ''; dd.hidden = d === 0; }
      if(hh) hh.textContent = dos(h); if(mm) mm.textContent = dos(m); if(ss) ss.textContent = dos(s);
    }
    var t = setInterval(tic, 1000); tic();
  };

  /* ---------- fecha estimada de entrega: hoy + 10 a hoy + 15 días (Ecuador) ---------- */
  T.fechaEntrega = function(min, max){
    var p = {};
    try { new Intl.DateTimeFormat('en-CA', { timeZone: ZONA, year:'numeric', month:'2-digit', day:'2-digit' }).formatToParts(new Date()).forEach(function(x){ p[x.type] = x.value; }); }
    catch(e){ var n = new Date(Date.now() - 5 * 3600 * 1000); p = { year: n.getUTCFullYear(), month: n.getUTCMonth() + 1, day: n.getUTCDate() }; }
    var base = Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day));
    var a = new Date(base + min * 86400000), b = new Date(base + max * 86400000);
    var dia = function(x){ return x.toLocaleDateString('es', { weekday:'long', timeZone:'UTC' }); };
    var mes = function(x){ return x.toLocaleDateString('es', { month:'long', timeZone:'UTC' }); };
    var A = dia(a) + ' ' + a.getUTCDate(), B = dia(b) + ' ' + b.getUTCDate() + ' de ' + mes(b);
    if(a.getUTCMonth() !== b.getUTCMonth()) A += ' de ' + mes(a);
    return 'Llega entre el ' + A + ' y el ' + B;
  };

  function iniciar(raiz){
    (raiz || document).querySelectorAll('[data-x13t-reloj]').forEach(T.reloj);
    (raiz || document).querySelectorAll('[data-x13t-entrega]').forEach(function(el){
      el.textContent = T.fechaEntrega(Number(el.getAttribute('data-min') || 10), Number(el.getAttribute('data-max') || 15));
    });
  }

  /* ---------- secciones del carrito que se vuelven a dibujar al cambiar el carrito ---------- */
  T.refrescar = function(){
    document.querySelectorAll('[data-x13t-refrescar]').forEach(function(el){
      var id = el.getAttribute('data-x13t-refrescar'), caja = document.getElementById('shopify-section-' + id);
      if(!caja) return;
      fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id)).then(function(r){ return r.text(); }).then(function(html){
        var d = new DOMParser().parseFromString(html, 'text/html'), nuevo = d.getElementById('shopify-section-' + id);
        if(nuevo){ caja.innerHTML = nuevo.innerHTML; iniciar(caja); }
      }).catch(function(){});
    });
  };
  function suscribir(){
    if(typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function(){ setTimeout(T.refrescar, 50); });
    else if(typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function(){ setTimeout(T.refrescar, 50); });
  }
  document.addEventListener('x13t:carrito', function(){ if(!enCarrito()) T.refrescar(); });
  T.iniciar = iniciar;
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ iniciar(); suscribir(); }); else { iniciar(); suscribir(); }
  document.addEventListener('shopify:section:load', function(e){ iniciar(e.target); });
})();
